import styled from "styled-components";
import { colors, types } from "../../../libs";

export const StyledCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid transparent;
  background: ${colors.background.lightBlack};
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  width: 100%;
  cursor: pointer;
`;

export const LeftSection = styled.div`
  flex: 1;
  text-align: left;
`;

export const Title = styled.div`
  ${types.body.normal};
  font-weight: bold;
  color: ${colors.text.white};
`;

export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 4px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LinkStatusIcon = styled.div<{ $isLinked: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.$isLinked ? '#28a745' : '#dc3545'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 60px;
  height: 32px;
  background: ${colors.background.lightGrey};
  border-radius: 50px;
  padding: 2px;
`;

export const ControlIndicator = styled.div<{ $isEnabled: boolean }>`
  position: absolute;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${props => props.$isEnabled ? colors.background.green : "#dc3545"};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s ease;
  transform: translateX(${props => props.$isEnabled ? '28px' : '0px'});
  z-index: 1;
`;

export const ControlButton = styled.button<{ $isActive?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: ${props => props.$isActive ? colors.text.black : colors.text.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: color 0.3s ease;
  z-index: 2;
  position: relative;

  &:hover {
    opacity: 0.8;
  }
`;

export const ActionIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.background.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.text.white};
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${colors.background.greyWhite};
  }
`;

export const Circle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50px;
  background: ${colors.background.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: ${colors.background.greyWhite};
  }
`;
